import axios from 'axios';

// Referidos, atribución y notificaciones (propuesta integral Fase 4).
export default {
  // Referidos
  listReferrals(status) {
    return axios.get('/referrals', { params: status ? { status } : {} });
  },
  rejectReferral(id, reason) {
    return axios.post(`/referrals/${id}/reject`, { reason });
  },
  customerReferrals(customerId) {
    return axios.get(`/customers/${customerId}/referrals`);
  },

  // Notificaciones
  listRules() {
    return axios.get('/notification-rules');
  },
  createRule(data) {
    return axios.post('/notification-rules', data);
  },
  updateRule(id, data) {
    return axios.put(`/notification-rules/${id}`, data);
  },
  deleteRule(id) {
    return axios.delete(`/notification-rules/${id}`);
  },
  notificationLog(params) {
    return axios.get('/notifications/log', { params });
  },
  testNotification(ruleId, customerId) {
    return axios.post('/notifications/test', { rule_id: ruleId, customer_id: customerId });
  },

  // Marketing spend / metas
  listSpend(params) {
    return axios.get('/marketing-spend', { params });
  },
  createSpend(data) {
    return axios.post('/marketing-spend', data);
  },
  listGoals(period) {
    return axios.get('/sales-goals', { params: period ? { period } : {} });
  },
  upsertGoal(data) {
    return axios.post('/sales-goals', data);
  },
  deleteGoal(id) {
    return axios.delete(`/sales-goals/${id}`);
  },

  // QR de sucursal
  regenerateQr(sucursalId) {
    return axios.post(`/sucursal/${sucursalId}/qr/regenerate`);
  },
  qrPng(sucursalId) {
    return axios.get(`/sucursal/${sucursalId}/qr.png`, { responseType: 'blob' });
  }
}
